import { FC, useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { SBase, SButton, SText } from '@setvi/shared/components';
import CheckIcon from '@material-ui/icons/Check';
import moment, { Moment } from 'moment';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { DatePicker } from './date-picker';
import { IconWrapper, TitleContainer } from './styled';

const useStyles = makeStyles(() => ({
  content: {
    padding: '0 24px'
  },
  footer: {
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px 24px'
  }
}));

interface ExtendDateDialogProps {
  defaultDays?: number;
  isLoading?: boolean;
  onConfirm: (date: Moment) => void;
  onClose: () => void;
}

export const ExtendDateDialog: FC<ExtendDateDialogProps> = ({
  defaultDays = 10,
  isLoading = false,
  onConfirm,
  onClose
}) => {
  const classes = useStyles();
  const [selectedDate, setSelectedDate] = useState<Moment>(
    moment().add(defaultDays, 'days').startOf('day')
  );

  const handleDateChange = (date: Moment) => {
    setSelectedDate(date);
  };

  const handleConfirm = () => {
    onConfirm(selectedDate);
  };

  return (
    <SBase
      width={600}
      disablePadding
      style={{
        background: '#F8F9FA'
      }}
      header={{
        title: (
          <TitleContainer>
            <IconWrapper>
              <ErrorOutlineIcon htmlColor="#fff" />
            </IconWrapper>
            <SText
              title="Quote Expired - Action Required"
              fontColor="#20262D"
              weight="semibold"
              size="xl"
            />
          </TitleContainer>
        ),
        onClose
      }}>
      <Box className={classes.content}>
        <DatePicker
          selectedDate={selectedDate}
          onDateChange={handleDateChange}
        />
      </Box>
      <Box className={classes.footer}>
        <SButton
          color="default"
          variant="text"
          onClick={onClose}
          style={{
            borderRadius: 36,
            color: '#5D7083'
          }}>
          Cancel
        </SButton>
        <SButton
          onClick={handleConfirm}
          disabled={isLoading}
          loading={isLoading}
          startIcon={<CheckIcon style={{ fontSize: 18 }} />}
          style={{
            borderRadius: 36
          }}>
          Confirm
        </SButton>
      </Box>
    </SBase>
  );
};
